import { normalizeEmail, normalizeFullName, splitName } from "@/utils/gtm";

export const pushViewingBookedConversion = (props: {
  email: string;
  fullName: string;
  phoneNumber: string;
  income: number;
}) => {
  const { income, phoneNumber } = props;
  const email = normalizeEmail(props.email || "");

  const { firstName, lastName } = splitName(normalizeFullName(props.fullName));

  // User would be registered and booked a viewing at this stage.
  // So value = income/1000 * 3(registered = 1 + booked a viewing = 2) and round to the nearest 50
  const value = income > 50000 ? Math.round(((income / 1000) * 3) / 50) * 50 : 0;

  if (email.endsWith("@keyzy.com")) {
    console.log("Skipping viewing booked conversion for keyzy.com email");
    return;
  }
  window.dataLayer.push({
    event: "viewingBooked",
    event_category: "Application",
    currency: "GBP",
    value: value,
    user_data: {
      email_address: email,
      first_name: firstName,
      last_name: lastName,
      phone_number: phoneNumber,
    },
  });

  // Push a custom event to trigger the Facebook Pixel conversion for viewing booked
  window.dataLayer.push({
    event: "SUBMIT_APPLICATION",
    event_category: "Application",
    currency: "GBP",
    value: value,
    user_data: {
      email_address: email,
      first_name: firstName,
      last_name: lastName,
      phone_number: phoneNumber,
    },
  });
};
